const TEXT = {
    APPLY_STEP3_TEXT_1:"微商",
    APPLY_STEP3_TEXT_2:"店铺",
    APPLY_STEP3_TEXT_3:"微信",
    APPLY_STEP3_TEXT_4:"支付宝",
    APPLY_STEP3_TEXT_5:"银行",

    APPLY_STEP3_TEXT_6:"淘宝",
    APPLY_STEP3_TEXT_7:"京东",
    APPLY_STEP3_TEXT_8:"小红书",
    APPLY_STEP3_TEXT_9:"唯品会",
    APPLY_STEP3_TEXT_10:"云集",
    APPLY_STEP3_TEXT_11:"申请方式",
    APPLY_STEP3_TEXT_12:"汇款方式",

    APPLY_STEP3_TEXT_13:"汇款账号",
    APPLY_STEP3_TEXT_14:"汇款金额",
    APPLY_STEP3_TEXT_15:"收款人姓名",
    APPLY_STEP3_TEXT_16:"收款人账号",
    APPLY_STEP3_TEXT_17:"提交",
    APPLY_STEP3_TEXT_18:"汇款凭证",
    APPLY_STEP3_TEXT_19:"汇款人姓名"
};
export {
	TEXT
}












// WEBPACK FOOTER //
// ./src/config/page/cn/apply/step4/index.js